import { type ClassValue, clsx } from 'clsx'
import { format, formatRelative } from 'date-fns'
import { enUS, sv } from 'date-fns/locale'
import type { TFunction } from 'i18next'
import { twMerge } from 'tailwind-merge'
import i18n from '@/i18n'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

const formatToken = (t: TFunction<'sv', undefined>) => {
  return {
    lastWeek: 'd MMMM',
    today: `'${t('global.dates.today')}' HH:mm`,
    yesterday: `'${t('global.dates.yesterday')}' HH:mm`,
    tomorrow: 'd MMMM',
    nextWeek: 'd MMMM',
    other: 'd MMMM',
  }
}

export const DateUtils = {
  formatDayAndTimeDate: (date: Date) => format(date, 'd MMM HH:mm'),
  formatShortDate: (date: Date) => format(date, 'yyyy-MM-dd'),
  formatRelativeDate: (date: Date, t: TFunction<'sv', undefined>) => {
    const now = new Date()
    const relativeDate = formatRelative(date, new Date(), {
      locale: {
        ...(i18n.language === 'sv' ? sv : enUS),
        formatRelative: token => formatToken(t)[token] ?? formatToken(t).other,
      },
    })
    const isSameYear = date.getFullYear() === now.getFullYear()
    return isSameYear ? relativeDate : `${relativeDate}, ${format(date, 'yyyy')}`
  },
}
